import { Helmet } from "react-helmet";

const Policy = () => {
	return (
		<>
			<Helmet>
				<title>Privacy Policy</title>
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			<div className="page policy">
				<h1>Emissary Health, Inc. Privacy Policy</h1>
				<div className="update">Last update: February 23, 2022</div>

				<p>
					Emissary Health offers various services to help its users find, coordinate, and maintain
					quality care. Emissary Health’s Privacy Policy (“Privacy Policy”) is designed to explain
					the information we collect and how we use it to provide our services and give users a
					better experience. It applies to any users of <a href="https://emissaryhealth.org">https://emissaryhealth.org</a> and any web
					pages, mobile applications and mobile websites operated by Emissary Health
					(collectively, the “Site”), including those who are seeking to find an individual or shared
					service provider through Emissary Health (“Care Managers”) as well as those who are
					looking to promote their services through Emissary Health (“Care Providers”), and any
					users of any of the various services that Emissary Health provides through the Site or
					any other channels.<br /><br />
					For purposes of this Privacy Policy, the terms “Emissary Health,” “we,” “us,” and “our”
					refer to Emissary Health, Inc. “You” refers to you, as a visitor or user or the Site. This
					Privacy Policy does not apply to third party entities that may use the Site. Such entities’
					use of the Site subject to separate terms that they agreed to when they registered or
					otherwise contracted with Emissary Health. Other capitalized terms that are not
					expressly defined in this Privacy Policy have the same meaning as set forth in the
					Emissary Health Terms of Use.
					By using the Site, you consent to our collection, storage, use and disclosure of your
					information as described in this Privacy Policy.
				</p>

				<div className="divider" />

				<p>
					<b>1. Information We Collect and their Sources</b>
				</p>


				<p>
					How we collect and store information depends on the Services you use and the
					activities in which you participate. You can use some of the Site without providing any
					information other than that automatically collected as described below. Visitors who
					access and browse the Site without registering are “Site Visitors.” In order to utilize
					some of the Services offered by Emissary Health, you must register with Emissary
					Health. All users who register with Emissary Health are “Registered Users.”
				</p>

				<div className="divider"></div>

				<p><b>2. Information you provide</b></p>
				<p>
					Regardless of whether you are a Site Visitor or a Registered User, all information that
					you provide to us when registering, posting a job, posting a profile, communicating
					through the Site or that you otherwise provide on the Site will be stored by us. You
					represent and warrant to us that you have the right and authority to provide us all
					information you provide about yourself or others. You may provide us with information in
					various ways, including:
				</p>

				<p><b>A. When registering</b></p>
				<p>
					When you register directly through Emissary Health, we will collect and store the
					information that you provide to us on our online registration forms. This may include,
					among other information, your:

				</p>
				<ul className="list-dot">
					<li><p>first and last name</p></li>
					<li><p>email address</p></li>
					<li><p>home address</p></li>
					<li><p>gender</p></li>
					<li><p>birthday</p></li>
					<li><p>phone number</p></li>
				</ul>

				<div className="divider" />
				<p>
					Some users may have the opportunity to register with Emissary Health by connecting
					through Google’s application programming interface (API). If you register for a Service
					that requires you to pay a fee, Emissary Health will also collect your payment method
					details, such as account number, expiration date, and security code, as well as your
					billing address, for payment purposes and your birthday, if not previously provided.
				</p>

				<div className="divider" />

				<p><b>B. When posting a profile</b></p>
				<p>
					If you are a Care Provider or Care Manager, we collect and store all of the additional
					information that you provide to us in your profile. This may include, among other
					information:

				</p>
				<div className="divider" />
				<ul className="list-dot">
					<li><p>details on the care you offer, including for example the type of care you provide,
						your availability, your</p></li>
					<li><p>related services you provide</p></li>
					<li><p>pictures you choose to post</p></li>
					<li><p>your phone numbers</p></li>
					<li><p>references, if you choose to provide them</p></li>
					<li><p>information you may provide on a family member</p></li>
					<li><p>any other information you choose to include in your profile</p></li>
				</ul>


				<div className="divider" />
				<p><b>C. Otherwise through the Site or by telephone, email, postal mail or chat</b></p>
				<p>
					Certain Registered Users may provide additional information on the Site through other
					Site features and offerings such as our online communication platforms. In some cases,
					Site Visitors may have the ability to provide us information through the Site, such as
					contact information. We collect and store all of the information you provide us through
					these channels. Moreover, if you provide information about someone other than yourself
					through any of these channels, you represent that you have authority to do so.
				</p>

				<div className="divider"></div>

				<p><b>3. Information provided by others</b></p>
				<div className="divider" />
				<p><b>A. By Site Visitors, Registered Users and others</b></p>
				<p>
					Emissary Health also captures and collects information that Site Visitors, Registered
					Users and others provide about one another. For example, Care Providers may invite
					Site Visitors, Registered Users or others to rate and indicate their relationship to the
					Care Provider on the Site. Additionally, certain Registered Users may post reviews
					about individual Care Providers. Site Visitors, Registered Users and others also may
					provide us information about Registered Users by phone, email or postal mail. Emissary
					Health captures and stores all information it receives from Site Visitors, Registered
					Users and others about other Registered Users and Site Visitors.
				</p>

				<div className="divider" />
				<p><b>B. By third parties to verify your information and representations</b></p>
				<p>
					In order to promote the safety and integrity of the Site and Service, you authorize
					Emissary Health, as provided in the Terms of Use, to utilize third party service providers
					to check your information on an ongoing basis against a variety of sources, which may
					include, but are not limited to, national criminal databases, sex offender registries,
					certain media streams, terrorist watch lists, criminal and fugitive watch lists, fraud watch
					lists, law enforcement reports, and other data to assist us in verifying the information
					you provide us (such as your name, address, email address, etc.) and the
					representations and warranties you make in the Terms of Use and on the Site (such as
					representations regarding your criminal background) (“Preliminary Membership
					Screens”). No mobile information will be shared with third parties or affiliates for marketing purposes.

				</p>

				<div className="divider" />
				<p><b>C. By Google if you connect to Emissary Health through Google</b></p>
				<p>
					You may have the opportunity to connect to Emissary Health through Google’s API
					when you register for Emissary Health or after you have registered for Emissary Health.
					If you connect to Emissary Health through Google, either when you register or after you
					have registered, we will collect, store, and use in accordance with this Privacy Policy
					any and all information you agreed that Google could provide to Emissary Health
					through its API. Your agreement (and our access to your information) takes place when
					you instruct, accept or allow Google to register you for an Emissary Health account or
					otherwise connect to Emissary Health through Google. The information Emissary Health
					may access, collect and store may include the following, among other information, as
					allowed by you, Google’s API, and your Google privacy settings:
				</p>
				<div className="divider" />
				<ul className="list-dot">
					<li><p>your name</p></li>
					<li><p>your profile picture</p></li>
					<li><p>your email address</p></li>
					<li><p>your gender</p></li>
					<li><p>your birthday</p></li>
					<li><p>your location (i.e. city)</p></li>
					<li><p>your interests and affinity networks</p></li>
					<li><p>other information you make publicly available via Google</p></li>
				</ul>

				<div className="divider" />
				<p><b>D. By other sources</b></p>
				<p>
					In addition, we may obtain information about you from other sources (e.g., partners,
					researchers, marketers, etc.), such as demographic data, and other information to
					enable us to comply with regulatory requirements, ensure the accuracy of data, better
					understand your likely interests, prevent fraud, etc. We may combine information that
					we collect from you with information about you from such other sources and use it in
					accordance with this Privacy Policy
				</p>

				<div className="divider"></div>

				<p><b>3. Information you expressly authorize us to collect</b></p>
				<p>
					We may from time to time request permission to collect certain information from or
					about you. If you grant your permission, we will access and/or store such information
					unless you subsequently opt out by adjusting the settings on your devices.
				</p>

				<div className="divider"></div>

				<p><b>4. Automatically collected information</b></p>
				<p>
					We may automatically collect certain information about the computer or devices you use
					to access the Site and Services as described in this section below.
				</p>

				<div className="divider" />
				<p><b>A. Log files, IP addresses and information about your computer and mobile device</b></p>
				<p>
					When you visit the Site, Emissary Health receives the internet protocol (“IP”) address of
					your computer (or the proxy server you use to access the internet), your computer
					operating system, the type of web browser you are using, and browser language. We
					may correlate this information with other information we have about you. We may also
					automatically collect information related to the ways in which you interact with the Site
					and the Services, such as referring and exit pages, URLs, platform type, the number of
					clicks, domain names, landing pages, pages and content viewed (including ads viewed)
					and the order of such views, the amount of time spent on particular pages, the date and
					time you use the Services, error logs, and other similar information.

				</p>

				<div className="divider" />
				<p><b>B. Cookies and other technologies</b></p>
				<p>
					A cookie is a tiny data file that resides on your computer, mobile phone, or other device,
					and allows us to recognize you when you return to the Site using the same computer (or
					mobile device) and web browser. Like most websites, we and our service providers use
					cookies, and tracking pixels to track Site usage and trends, evaluate the effectiveness
					of our ads both on and off our Site, customize your experience on the Site and improve
					the quality of our Services. For example, using these technologies we can determine,
					among other things, which pages of our Site you visit and which ads you click on. Most
					browsers automatically accept cookies, but you can modify your browser settings to
					decline cookies. In some cases, however, doing so may impact your ability to use
					Emissary Health. Tracking pixels do not identify individual users, and the analysis of
					data obtained by tracking pixels is performed on an aggregate basis.
				</p>

				<div className="divider" />
				<p><b>C. Online analytics and advertising</b></p>
				<p>
					When you visit our Site or open one of our emails, we may allow authorized third
					parties, such as ad servers, ad agencies, ad exchanges, ad technology vendors, and
					research firms, to place or recognize a unique cookie, pixel, and/or similar technologies
					on your browser in order to provide you relevant Emissary Health advertisements as
					you surf the Internet. These advertisements may be targeted to you based on
					information these authorized third parties know or infer about you and include in the
					cookies placed on your browser, and/or on information about your Internet browsing
					activities gathered through your browser. If you prefer not to receive these online
					behavioral advertisements, you may opt-out. In order for the opt-out to work, your
					browser must be set to accept third party cookies. Furthermore, if you buy a new
					computer or device, change web browsers or delete the opt-out cookie, you will need to
					perform the opt-out task again. Please note that if you opt-out you may continue to
					receive Emissary Health advertisements as you surf the Internet, including contextual
					ads based on the content on a webpage you are visiting. However, these
					advertisements will not be displayed based on information contained in, or collected by,
					cookies or other technologies placed on your browser when you visit our Site or open
					our emails.
					<br /><br />
				</p>
				<p>
					We also may use Google Analytics to measure Site usage and improve our visitor
					experience. The relevant data is provided to us by Google in the aggregate (i.e.,
					individual users are not identified) and allows us to better understand our Site audience.
					The Google Analytics features implemented by us allow us (i) to evaluate and generate
					reports on certain demographic, behavioral, and interest metrics of users collected by
					Google, and (ii) to create advertising remarketing audiences and campaigns based on
					such metrics, which may be segmented into aggregated groups. Visitors can opt-out of
					Google Analytics for Display Advertising and customize Google Display Network ads
					using the Ads Settings form at <a href="https://www.google.com/settings/ads">https://www.google.com/settings/ads</a>.<br /><br />
				</p>
				<p>
					Do Not Track Notice. Some browsers used to access the Internet may give you the
					option through “Do Not Track” settings associated with such browsers to request that a
					website operator not track your information across its website or other websites. We
					engage in such tracking in order to optimize and/or customize our Services, detect and
					respond to allegations of fraud, and to otherwise ensure the safety of our Registered
					Users and Site Visitors. While we do not currently honor such browser requests, we will
					not use your information in a manner that violates this Privacy Policy. In addition, you
					retain the ability to opt out of certain online analytics and advertising activities as
					discussed in this section above.
				</p>

				<div className="divider" />
				<p><b>5. Purposes For Which We Use Information</b></p>
				<p>
					In general, the information we collect is used for our business purposes: (1) to improve
					our Services and enhance your experience with Emissary Health, (2) to enable us to
					provide a safer community for all of our Registered Users, and (3) to help us
					communicate with you. For example, we may use your information to:

				</p>
				<div className="divider" />
				<ul>
					<li><p>1. register and service your account;</p></li>
					<li><p>2. include in Care Manager profiles, job postings and Care Provider profiles;</p></li>
					<li><p>3. contact you in response to questions and solicit feedback and input from you;</p></li>
					<li><p>4. notify you about new features, special events, or products, services, and special
						offers, or other information that we believe will be of interest to you via email,
						SMS messages, or other media or networks;</p></li>
					<li><p>5. administer sweepstakes and contests;
					</p></li>
					<li><p>6. enable Care Managers with each other and with Care Providers to search based
						on the information the other has made available on the Site, and information
						others have provided about them;
					</p></li>
					<li><p>7. connect Care Managers with Care Providers that appear to meet their needs and
						preferences;</p></li>
					<li><p>8. enable Registered Users to search for, find, interact, connect and share
						information with other Registered Users they may have an interest in interacting
						with;</p></li>
					<li><p>9. verify information you provide us as well as the representations and warranties
						you make to us in the Terms of Use or on the Site;</p></li>
					<li><p>10. perform analytics and research aimed at improving the accuracy, effectiveness,
						usability, or popularity of the Services;
					</p></li>
					<li><p>11. generate and review reports and data about our user base and usage patterns,
						including to improve the content and features of the Services or develop new
						Services;</p></li>
					<li><p>12. otherwise help protect the safety and integrity of the Site and Emissary Health
						users; and</p></li>
					<li><p>13. personalize promotional messages or content on the Site, via email or other ads
						on Emissary Health or third party sites.
					</p></li>
				</ul>

				<div className="divider" />
				<p>
					We may aggregate and/or de-identify information collected by the Site or via other
					means so that the information is not intended to identify you. Our use and disclosure of
					aggregated and/or de-identified information is not subject to any restrictions under this
					Privacy Policy, and we may disclose it to others without limitation for any purpose.
				</p>

				<div className="divider" />
				<p><b>6. How We Share and Categories of Third Parties With Whom We Share Information</b></p>
				<p>
					In addition to using the information collected by Emissary Health for the purposes
					described above, we may also share your information with various third parties, as
					described below. Please review our sharing policy closely. By using our Site or our
					Services, you agree to allow us to share the information you provide to us in the ways
					described below.
				</p>

				<div className="divider" />
				<p><b>7. With All Site Visitors and Registered Users</b></p>
				<p>
					If you are a Care Provider, in order to increase your chances of finding a job or finding
					the care you need, we share with Site Visitors and Registered Users the information
					that is included in your job posting or profile, aside from your contact information, as
					well as the following registration information, which we may include in your job posting
					or profile: your first name, first initial of your last name, city, state, profile picture, and if
					you are a Care Provider, your gender and, unless you opt-out, your age. With certain
					exceptions, you choose how much detail you want to include in either your job posting
					or your profile. We may display personal testimonials of Registered Users and other
					endorsements on our Site or in other marketing materials. These testimonials or
					endorsements may include information such as the Registered User’s first name, first
					initial of last name, town and state. With a Registered User’s consent, we may include
					their full name.

				</p>

				<div className="divider" />
				<p><b>8. With other Registered Users</b></p>
				<p>
					In addition to the information that is provided to all Registered Users and Site Visitors,
					Care Provider reviews and references are made available to certain Registered Users.
					If you are a Care Provider, your phone number may be visible to certain Registered
					Users if you elect to share it in your profile. In addition, your approximate residential
					location (through Google map plotting) is made available to certain Registered Users
					and Site Visitors unless you elect to keep that information confidential.

				</p>
				<br />
				<p>If you are a Care Provider, you will appear in search result listings if you match the
					search criteria used by a Care Manager, as applicable.
				</p>

				<div className="divider" />
				<p><b>9. With vendors/service providers</b></p>
				<p>
					We also share information with vendors with whom we have a contractual relationship
					and who perform services for Emissary Health including, without limitation, vendors who
					provide email, demographic information, or geo-location information services, vendors
					who perform background checks or Preliminary Membership Screens, vendors who
					process or accept credit card payments, vendors who run classified advertising
					businesses, vendors who send SMS messages to Registered Users’ mobile phone
					numbers, vendors who provide services that enable us and other third parties to detect
					and prevent fraud, in each case to the extent applicable. In certain cases (such as for
					vendors who help facilitate our online communication services or provide fraud
					detection and prevention services), the information we share may include the contents
					of messages you send through our online communication platforms. We may have
					Google’s Invisible reCAPTCHA technology on our site. Use of the Invisible reCAPTCHA
					is subject to the <a href="https://policies.google.com/privacy?hl=en">Google Privacy Policy</a> and <a href="https://policies.google.com/terms?hl=en">Terms of Use</a>
				</p>

				<div className="divider" />
				<p><b>10. As required by law or for reasons of safety</b></p>
				<p>
					We may disclose your information when we believe in good faith that such disclosure is
					appropriate in order to investigate, prevent, or take action regarding possible illegal
					activities, suspected fraud, situations involving potential threats to the health or physical
					safety of any person, violations of this Privacy Policy, or the Terms of Use, and/or to
					protect the rights and property of Emissary Health, our employees, users, and the
					public. This may involve the sharing of your information with law enforcement,
					government agencies, courts, and/or other organizations.

				</p>

				<div className="divider" />
				<p><b>11. With Your Consent</b></p>
				<p>
					We also may share your information with a third party if you consent to the sharing.
				</p>

				<div className="divider" />
				<p><b>12. Background Checks</b></p>
				<p>
					Emissary Health requires background check services from consumer reporting agencies
					for Care Providers. You acknowledge that sensitive material may be included in your
					background check, and that you are responsible for providing us and our service
					provider (if applicable) with correct information. The service provider who completes the
					background check may send the results to you by email or postal mail.
				</p>

				<div className="divider" />
				<p><b>13. Business Transactions</b></p>
				<p>
					In the event we go through a business transition such as a merger, acquisition by
					another company, or sale of all or a portion of our assets, your information may be
					among the assets transferred. You acknowledge and consent that such transfers may
					occur and are permitted by this Privacy Policy, and that any acquirer of ours or that
					acquirer’s affiliates may continue to process your information as set forth in this Privacy
					Policy.

				</p>

				<div className="divider" />
				<p><b>14. Your Communication Choices</b></p>
				<p>
					By becoming a Registered User, you are consenting to receive certain email
					communications from us, such as special offers, tips and advice, notifications of new
					Care Managers or Care Providers in your area, customer surveys and administrative
					notices. You have a choice at any time to stop us from sending you emails for marketing
					purposes by adjusting your settings in your account settings. You also have the option
					to opt out of receiving certain other emails from Emissary Health, such as certain
					educational emails, by adjusting your settings in your account settings. Go to your
					account settings for a complete list of the email types you may opt out of receiving. You
					can also opt out of commercial email messages by following the “unsubscribe” link
					included in these messages. Please note that despite any indicated email marketing
					preferences, we may continue to send you administrative emails regarding Emissary
					Health, including, for example, notices of updates to our Privacy Policy, if we choose to
					provide such notices to you in this manner. If you are a Care Provider or Care Manager,
					certain Care Providers or Managers may initiate contact with you directly using the
					messaging features of the Emissary Health Site.
				</p>

				<div className="divider" />
				<p><b>15. Changing or Removing your Personal Information and Closing your Account</b></p>
				<p>
					You can update certain of your information by logging into your account and accessing
					your account settings. If you would like to remove some of the information you have
					posted on the Site, such as information you posted in profiles and job postings, you may
					do so by editing or deleting that item in your My Profile & Settings area or your My Jobs
					area. If you no longer wish to participate in our Services, please email
					support@emissaryhealth.org. If you close your Emissary Health account, we will
					remove your name and other contact and identifiable information from our publicly
					viewable database. If you close your account, we have no obligation to retain your
					information, and may delete any or all of your account information without liability.
					However, we may retain information related to you if we believe it may be necessary to
					prevent fraud or future abuse, or for legitimate business purposes, such as analysis of
					aggregated, de-identified information, account recovery, auditing our records, enforcing
					our rights and obligations under our agreements, or if required by law. Emissary Health
					may also retain and use your information if necessary to provide the Services to other
					Registered Users. For example, just as an email you may send to another person
					through an email service provider resides in that person’s inbox even after you delete it
					from your sent files or close your account, emails you send through Emissary Health to
					other Users, as well as your contributions to Emissary Health groups, may remain
					visible to others after you have closed your account. Similarly, other information you
					have shared with others, or that others have copied, may also remain visible. Emissary
					Health disclaims any liability in relation to the deletion or retention (subject to the terms
					herein) of information, or any obligation not to delete the information. Emissary Health
					does not control when search engines update their search index or cache, which may
					contain certain job posts, profiles or other information that have since been removed
					from Emissary Health’s Site.
				</p>

				<div className="divider" />
				<p><b>7. Collection of Information from Children</b></p>
				<p>
					Emissary Health’s Site and Services are not intended for individuals under the age of
					16. Moreover, if we become aware that we receive personal information from children
					under the age of 16, we will take reasonable steps to delete it as soon as practicable.
				</p>

				<div className="divider" />
				<p><b>8. How We Protect Information</b></p>
				<p>
					We have implemented a variety of administrative, technical, and physical security
					measures to protect against the unauthorized access, destruction, or alteration of your
					information. These safeguards vary based on the sensitivity of information that we
					collect, process, and store and the current state of technology.
					<br /><br />
					Although we take appropriate measures to safeguard against unauthorized disclosures
					of information, we cannot guarantee that information that we collect will never be
					disclosed in a manner that is inconsistent with this Privacy Policy
				</p>

				<div className="divider" />
				<p><b>9. Links to Other Websites</b></p>
				<p>
					The Site and Services may contain links to third-party websites and services. However,
					we are not responsible for the privacy practices employed by those web sites or
					services, nor are we responsible for the information or content they contain. This
					Privacy Policy applies solely to information collected by us through the Site and
					Services; thus when you use a link to go from the Site to a third-party web site or
					service, this policy is no longer in effect and the privacy policy of such third-party site or
					service will govern.
				</p>

				<div className="divider" />
				<p><b>10. Changes to Our Privacy Policy</b></p>
				<p>
					Emissary Health reserves the right to change this Privacy Policy and our Terms of Use
					at any time. We will notify you about and provide you with choice about material
					adverse changes to this Privacy Policy or in our practices as required by applicable law.
					Material adverse changes will go into effect 30 days after we notify. Non-material
					changes or clarifications will take effect immediately upon posting of the updated policy
					on our Site. You should periodically check our Privacy Policy page for updates. Your use
					of the Site after such effective date will constitute acceptance by you of such changes.
				</p>

				<div className="divider" />
				<p><b>11. Privacy Information for California Residents</b></p>
				<p>Throughout this Privacy Policy, we discuss the specific pieces of personal information
					we collect from and about users of our Site. In accordance with the CCPA, as amended
					by the California Privacy Rights Act of 2020, we are providing you with additional
					information about the personal information we collect from California residents, how we
					disclose that personal information, and your privacy rights.
					<br /><br />
					Personal Information We Collect, Use, and Disclose
					<br /><br />
					As discussed throughout this Privacy Policy, we collect personal information directly
					from you, from our vendors and clients, and from the cookies and tracking technologies
					we use. The specific categories of personal information vary depending on the Site you
					engage with and how you use them. In the past year we have collected and anticipate
					continuing to collect the following types of personal information from users and visitors
					of our Site. For each category of personal information, we provide additional details
					about how we use and disclose the personal information we collect.
					<br /><br />
					Identifiers and Other Non-Public Personal Information as described in California Civil
					Code § 1798.80(e), including, for example, name, address, email address, phone
					number, driver’s license, and/or IP address. We may use this personal information to
					provide services you have requested from us; to respond to inquiries; to service your
					account; for our day-to-day business operations; to protect against fraud or
					unauthorized transactions; and for safety and compliance. We may disclose your
					personal information within our corporate group and to our vendors and business
					partners to ensure security and integrity of our Site and Services; to provide services
					you request; as reasonably necessary to operate our business, including internal
					research and development; to perform activities to verify or maintain the quality or
					safety of our systems, Site, and to improve, upgrade, or enhance them; to identify and
					repair errors in the functionality of our systems, Site; to detect and prevent illegal or
					malicious acts or violations of our policies or terms; and, as needed, to use for other
					short-term, transient purposes.
					<br /><br />
					Characteristics of Protected Classifications, including, for example, gender or gender
					identity, health/medical conditions, and/or information obtained from a background
					check. We may use characteristics of protected classifications to provide services you
					have requested from us; to respond to inquiries; to service your account; and for safety
					and compliance. We may disclose your characteristics of protected classifications within
					our corporate group and to our vendors and business partners to ensure the security
					and integrity of our Site; to provide services you request; and as reasonably necessary
					to operate our business, including internal research and development; and to detect and
					prevent illegal or malicious acts or violations of our policies or terms.
					<br /><br />
					Commercial Information, including, for example, transaction data, purchase or use
					history or tendency, financial data (such as payment method details and billing
					address), and/or services purchased, obtained, or considered. We may use commercial
					information to provide services you have requested from us; to evaluate and improve
					our Site; to respond to inquiries; for our day-to-day business purposes; to service your
					account; to help us better understand your preferences; to enhance your experience by
					personalizing our Site; to protect against fraud or unauthorized transactions; and for
					safety and compliance. We may disclose your commercial information within our
					corporate group and to our vendors and business partners to ensure the security and
					integrity of our Site and Services; to provide services you request; as reasonably
					necessary to operate our business, including internal research and development; to
					detect and prevent illegal or malicious acts or violations of our policies or terms; and, as
					needed, to use for other short-term, transient purposes.
					<br /><br />
					Internet or Other Electronic Network Activity, including, for example browsing history,
					search history, and/or information regarding your interactions with our Site. We may use
					internet or other electronic network activity to provide services you have requested from
					us, including access to our Site features; for our day-to-day business purposes,
					including development or improvement of our Site; to service your account; to protect
					against fraud or unauthorized transactions; and for safety and compliance. We may
					disclose your internet or other electronic network activity within our corporate group and
					to our vendors and business partners to ensure security and integrity of our Site; to
					provide services you request; to perform functions needed to operate our business,
					including internal research and development; to perform activities to verify or maintain
					the quality or safety of our systems, Site, and to improve, upgrade, or enhance them; to
					identify and repair errors in the functionality of our systems, Site; to detect and prevent
					illegal or malicious acts or violations of our policies or terms; and, as needed, to use for
					other short-term, transient purposes.
					<br /><br />
					Geolocation Information, including, for example, information about the approximate
					location of you or your device. We may use geolocation information to provide services
					you have requested from us, such as recommending Care Providers in your area; to
					enhance your experience by personalizing our Site; to protect against fraud or
					unauthorized transactions; and for safety and compliance. We may disclose your
					geolocation information within our corporate group and to our vendors and business
					partners to ensure security and integrity of our Site; to provide services you request; as
					reasonably necessary to operate our business; to identify and repair errors in the
					functionality of our systems, Site; to detect and prevent illegal or malicious acts or
					violations of our policies or terms; and, as needed, to use for other short-term, transient
					purposes.
					<br /><br />
					Audio, Visual, or Other Similar Information, including, for example, photos you upload to
					your profile. We may use this information to provide services you have requested from
					us; to respond to inquiries; to service your account; for our day-to-day business
					operations including development or improvement of our Site; to protect against fraud or
					unauthorized transactions; and for safety and compliance. We may disclose your
					information within our corporate group and to our vendors and business partners to
					ensure security and integrity of our Site; to provide services you request; as reasonably
					necessary to operate our business, including internal research and development; to
					perform activities to verify or maintain the quality or safety of our systems, Site, and to
					improve, upgrade, or enhance them; to identify and repair errors in the functionality of
					our systems, Site; and to detect and prevent illegal or malicious acts or violations of our
					policies or terms.
					<br /><br />
					Professional or Employment-Related Information, including, for example, Care Provider
					references, employment history, and/or certifications. We may use this professional
					information to provide services you have requested from us, including matching Care
					Providers with Care Managers; to respond to inquiries; to create and service your Care
					Provider profile and account; for our day-to-day business operations; to protect against
					fraud or unauthorized transactions; and for safety and compliance. We may disclose
					your professional information within our corporate group and to our vendors and
					business partners to ensure security and integrity of our Site; to provide services you
					request; as reasonably necessary to operate our business, including internal research
					and development; to perform activities to verify or maintain the quality or safety of our
					systems, Site, and to improve, upgrade, or enhance them; and to detect and prevent
					illegal or malicious acts or violations of our policies or terms.
					<br /><br />
					Inferences we draw from information we collect about you to create a profile of you,
					including, for example, information reflecting your preferences, characteristics, and/or
					predispositions. We may use inferences to provide services you have requested from
					us, including matching Care Providers with Care Managers and other content or
					information customization; for our day-to-day business operations; to protect against
					fraud or unauthorized transactions; and for safety and compliance. We may disclose
					inferences about you within our corporate group and to our vendors and business
					partners to ensure security and integrity of our Site; to provide services you request; as
					reasonably necessary to operate our business, including internal research and
					development; to perform activities to verify or maintain the quality or safety of our
					systems, Site, and to improve, upgrade, or enhance them; to identify and repair errors in
					the functionality of our systems, Site; and to detect and prevent illegal or malicious acts
					or violations of our policies or terms.
					<br /><br />
					Sensitive Personal Information, including, for example, your account login credentials,
					precise geolocation information, contents of communications between Care Providers
					and Care Managers on our Site, and/or health data. When collected, we only use or
					disclose sensitive personal information for the purposes allowed by the CCPA and its
					implementing regulations. We may use or disclose sensitive personal information when
					reasonably necessary to provide services you have requested from us or expect us to
					provide; to protect your physical safety or that of others; for our day-to-day business
					operations, including servicing your account and providing customer service; to protect
					against fraud or unauthorized transactions; to perform activities to verify or maintain the
					quality or safety of our systems, Site, and to improve, upgrade, or enhance them; and to
					detect and prevent illegal or malicious acts or violations of our policies or terms.
					<br /><br />
					In addition to the uses and disclosures of personal information described above, we
					may use and disclose any personal information we collect or maintain as reasonably
					necessary to comply with law and legal requirements; to cooperate with and respond to
					law enforcement requests; or as otherwise required by applicable law, court order,
					governmental regulation, or other legal process.
					<br /><br />
					Any personal information we collect and maintain may be provided to our professional
					advisors, including accountants, auditors, consultants, and lawyers, when reasonably
					necessary for our professional advisors to perform services for us and give us
					appropriate advice.
					<br /><br />
					Any personal information we collect and maintain may be given to another company in
					the event of a sale, merger, or other acquisition of some or all of our assets or business
					or as part of the negotiation or evaluation of such sale, merger, or other acquisition.
					<br /><br />
					Our Retention of Personal Information
					<br /><br />
					We keep personal information for as long as necessary to accomplish the purposes
					described in this Privacy Policy and Notice or as otherwise required or permitted by
					applicable law. This generally means holding your personal information for as long as at
					least one of the following applies:
					<br /><br />
					<ul className="list-dot">
						<li>
							<p>Your personal information is reasonably necessary to manage our business
								operations, including your relationship with us, or to satisfy another purpose for
								which we collected the information that was explained to you at the time of
								collection.
							</p>
						</li>
						<li>
							<p>
								Your personal information is reasonably necessary for a purpose that is
								compatible with a purpose explained to you at the time of personal information
								collection
							</p>
						</li>
						<li>
							<p>
								Your personal information is reasonably required to protect or defend our rights
								or property, including when it is anticipated that your personal information will be
								needed for a court proceeding or other legal process.

							</p>
						</li>
						<li>
							<p>
								We are required to keep your personal information for purposes of legal or
								regulatory compliance.

							</p>
						</li>
						<li>
							<p>
								We are otherwise permitted to keep your personal information in accordance with
								applicable law.
							</p>
						</li>
					</ul>
					<br /><br />
					For more information about our personal information retention practices, you may
					contact us using the contact details at the end of this Privacy Policy
					<br /><br />
					California Privacy Rights
					<br /><br />
					California residents have certain privacy rights related to the personal information we
					collect and maintain about them. Any California resident may exercise these privacy
					rights directly with us or through an authorized agent, who will use the same processes
					to submit privacy rights requests to us. You may exercise some privacy rights through
					your account, for example, updating your contact or profile details. You may exercise
					any of your privacy rights by submitting your requests by email to
					<a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>. We never discriminate against users who choose to
					exercise their privacy rights.
					<br /><br />
					Before responding to your privacy rights request, we may need to verify your identity.
					We typically verify your identity by (i) asking you to log in to your account with us, or (ii)
					matching two or more data points (for example, full name and email address) provided
					by you with data points maintained by us. If we are unable to verify your identity, we
					may request additional information from you.
					<br /><br />
					We respond to privacy requests as soon as possible and generally within 45 days. We
					will let you know if our response will take more than 45 days. We may comply with the
					request in whole or in part or deny the request in whole or in part. If we deny your
					request, we will let you know why, unless we are legally prohibited from doing so.
					<br /><br />
					Right to Know – You have the right to know about your personal information we collect
					and use. You also have the right to obtain a copy of your personal information.
					Specifically, you may ask us for the following:
					<br /><br />
					<ul className="list-dot">
						<li>
							<p>
								The categories of personal information we have collected about you;

							</p>
						</li>
						<li>
							<p>
								The categories of sources from which the personal information was collected;

							</p>
						</li>
						<li>
							<p>
								Our business or commercial purposes for collecting, selling, or sharing your
								personal information;

							</p>
						</li>
						<li>
							<p>
								The categories of personal information we have sold or shared about you and the
								categories of third parties to which each category of personal information was
								sold or shared;

							</p>
						</li>
						<li>
							<p>
								The categories of personal information we disclosed about you for a business
								purpose and the categories of persons to which it was disclosed; and/or

							</p>
						</li>
						<li>
							<p>
								The specific pieces of your personal information we have collected.

							</p>
						</li>
					</ul>
					<br /><br />
					Right to Correct – You may ask us to correct your personal information if you believe
					your personal information is inaccurate or incomplete.
					<br /><br />
					Right to Delete – You may ask us to delete your personal information.
					<br /><br />
					Right to Opt Out – We only “sell” or “share” personal information, as those terms are
					defined under the CCPA, through our use of third-party tracking technologies. You may
					opt out of the selling and sharing of personal information by clicking on the “Do Not Sell
					or Share My Personal Information” link in our Site footer and following the instructions
					provided.
					<br /><br />
					If you choose to use an opt-out browser signal, such as the Global Privacy Control, you
					will be opted out of our sale and sharing of personal information to the extent
					practicable.

					<div className="divider" />
					<p><b>12. Privacy Information for Virginia Residents</b></p>
					Throughout this Privacy Policy, we discuss the specific pieces of personal information
					we collect from and about users of our Site and how we use and disclose that personal
					information. In accordance with the Virginia Consumer Data Protection Act (VCDPA),
					we are providing you with additional information about your privacy rights.
					<br /><br />
					Virginia Privacy Rights
					<br /><br />
					Virginia residents have certain privacy rights related to the personal information we
					collect and maintain about them. You may exercise some privacy rights through your
					account, for example, updating your contact or profile details. You may exercise any of
					your privacy rights by contacting <a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>.
					<br /><br />
					Before responding to your privacy rights request, we may need to verify your identity.
					We typically verify your identity by (i) asking you to log in to your account with us, or (ii)
					matching two or more data points (for example, full name and email address) provided
					by you with data points maintained by us. If we are unable to verify your identity, we
					may request additional information from you.
					<br /><br />
					We respond to privacy requests as soon as possible and generally within 45 days. We
					will let you know if our response will take more than 45 days. We may comply with the
					request in whole or in part or deny the request in whole or in part. If we deny your
					request, we will let you know why, unless we are legally prohibited from doing so. If you
					disagree with our response, you have the right to appeal our decision. Information about
					exercising your right to appeal will be provided in our response to your privacy rights
					request.
					<br /><br />
					Right to Access – You have the right to request access to and obtain a copy of any
					personal data that we have related to you.
					<br /><br />
					Right to Correct – You may ask us to correct your personal information if you believe
					your personal information is inaccurate or incomplete.
					<br /><br />
					Right to Delete – You may ask us to delete your personal information.
					<br /><br />
					Right to Opt Out – We do not sell personal information or use personal information for
					profiling as those terms are defined in the VCDPA. We may process your personal
					information for targeted advertising, as that term is defined in the VCDPA, through our
					use of third-party cookies and tracking technologies. You have the right to opt out of
					targeted advertising. You may opt out of targeted advertising by clicking on the “Do Not
					Sell or Share My Personal Information” link in our Site footer and following the
					instructions provided.

					<div className="divider" />

					<p><b>13. Privacy Information for Nevada Residents
					</b></p>
					Under Nevada law, certain Nevada consumers may opt out of the sale of “personally
					identifiable information” for monetary consideration (as such terms are defined under
					Nevada law) to a person for that person to license or sell such information to additional
					persons. If you are a Nevada resident and you have purchased services or products
					from us, you may submit a request to opt out of any potential future sales under Nevada
					law by contacting <a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>. Please note we may take reasonable
					steps to verify your identity and the authenticity of the request.
				</p>

				<div className="divider" />
				<p><b>14. Contact Us
				</b></p>
				<p>
					If you have any questions on our Privacy Policy and practices, you can contact
					Emissary Health at:
				</p>
				<br /><br />
				<a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>
			</div>
		</>
	);
};

export default Policy;
